<template>
  <div class="w-full" :class="align === 'center' ? 'flex flex-col items-center' : ''">
    <div
      class="flex flex-wrap gap-4"
      :class="align === 'center' ? 'justify-center' : 'justify-end'"
    >
      <button
        type="button"
        @click="$emit('toggle')"
        class="px-6 py-2 bg-indigo-800/40 hover:bg-indigo-700/50
               rounded-full border border-indigo-500/40 hover:border-indigo-400/60
               transition-all duration-300 text-indigo-100
               sm:min-w-[140px] min-w-[160px] text-center"
      >
        Say Hello
      </button>

      <a
        href="https://calendly.com/johndavidspry/30min"
        target="_blank"
        rel="noopener noreferrer"
        class="px-6 py-2 bg-indigo-800/40 hover:bg-indigo-700/50
               rounded-full border border-indigo-500/40 hover:border-indigo-400/60
               transition-all duration-300 text-indigo-100
               sm:min-w-[140px] min-w-[160px] text-center"
      >
        Let's Meet
      </a>
    </div>

    <Transition name="contact-form">
      <div
        v-if="formOpen"
        class="mt-4 p-6 rounded-xl w-full
               bg-gradient-to-b from-gray-800/50 via-indigo-900/20 to-gray-900/50
               backdrop-blur-sm border border-indigo-500/30"
        :class="align === 'center' ? 'max-w-md' : ''"
      >
        <form @submit.prevent="$emit('submit')" class="space-y-4 text-left">
          <input
            :value="contactForm.name"
            type="text"
            placeholder="Name"
            required
            class="w-full px-4 py-2 rounded-lg bg-gray-900/50 border border-indigo-500/30
                   text-cream placeholder-cream/40 focus:border-indigo-400/60 outline-none"
            @input="updateField('name', $event.target.value)"
          />
          <input
            :value="contactForm.email"
            type="email"
            placeholder="Email"
            required
            class="w-full px-4 py-2 rounded-lg bg-gray-900/50 border border-indigo-500/30
                   text-cream placeholder-cream/40 focus:border-indigo-400/60 outline-none"
            @input="updateField('email', $event.target.value)"
          />
          <textarea
            :value="contactForm.message"
            placeholder="Your message"
            required
            rows="4"
            class="w-full px-4 py-2 rounded-lg bg-gray-900/50 border border-indigo-500/30
                   text-cream placeholder-cream/40 focus:border-indigo-400/60 outline-none resize-none"
            @input="updateField('message', $event.target.value)"
          />
          <button
            type="submit"
            :disabled="status === 'sending'"
            class="w-full px-6 py-2 bg-indigo-700/50 hover:bg-indigo-600/60
                   rounded-full border border-indigo-400/50 transition-all text-indigo-100
                   disabled:opacity-50"
          >
            {{ status === 'sending' ? 'Sending...' : 'Send Message' }}
          </button>
        </form>

        <p v-if="status === 'success'" class="mt-3 text-center text-indigo-300 text-sm">
          Thanks! I'll get back to you soon.
        </p>
        <p v-if="status === 'error'" class="mt-3 text-center text-red-300 text-sm">
          Something went wrong. Please try again or use Let's Meet to schedule a call.
        </p>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'ContactActions',
  props: {
    formOpen: {
      type: Boolean,
      default: false
    },
    contactForm: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      default: null
    },
    align: {
      type: String,
      default: 'end',
      validator: (value) => ['center', 'end'].includes(value)
    }
  },
  emits: ['toggle', 'submit', 'update:contactForm'],
  methods: {
    updateField(field, value) {
      this.$emit('update:contactForm', {
        ...this.contactForm,
        [field]: value
      });
    }
  }
};
</script>

<style scoped>
.contact-form-enter-active,
.contact-form-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.contact-form-enter-from,
.contact-form-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
